import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AlertProvider } from './context/AlertContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import UserManagement from './pages/UserManagement';
import Permissions from './pages/Permissions';
import Overview from './pages/Overview';
import Dashboard from './pages/Dashboard';
import Commands from './pages/Commands';
import Settings from './pages/Settings';
import OBSControl from './pages/OBSControl';
import Chat from './pages/Chat';
import Modules from './pages/Modules';
import Console from './pages/Console';
import Stats from './pages/Stats';
import StatsNew from './pages/StatsNew';
import Donations from './pages/Donations';
import Nexus from './pages/Nexus';
import Alerts from './pages/Alerts';
import ChatAlerts from './pages/ChatAlerts';
import TestAlerts from './pages/TestAlerts';
import Checkpoints from './pages/Checkpoints';
import Feedback from './pages/Feedback';
import SRTLAMonitor from './pages/SRTLAMonitor';
import OBSSync from './pages/OBSSync';
import RTMPMultistream from './pages/RTMPMultistream';
import ChatTimers from './pages/ChatTimers';
import Goals from './pages/Goals';
import OBSPresets from './pages/OBSPresets';
import OBSPresetsSettings from './pages/OBSPresetsSettings';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Laden...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">Laden...</div>;
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/test-alerts" element={<TestAlerts />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* Fullscreen Chat Route (ohne Sidebar) */}
      <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
      
      {/* Alle anderen Routes mit Sidebar */}
      <Route path="/*" element={
        <ProtectedRoute>
            <div className="app">
              <Sidebar />
              
              <main className="content">
                <Routes>
                  <Route path="/" element={<Overview />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/obs" element={<OBSControl />} />
                  <Route path="/obs-presets" element={<OBSPresets />} />
                  <Route path="/commands" element={<Commands />} />
                  <Route path="/chat-timers" element={<ChatTimers />} />
                  <Route path="/modules" element={<Modules />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/chat-alerts" element={<ChatAlerts />} />
                  <Route path="/test-alerts" element={<TestAlerts />} />
                  <Route path="/checkpoints" element={<Checkpoints />} />
                  <Route path="/feedback" element={<Feedback />} />
                  <Route path="/srtla" element={<SRTLAMonitor />} />
                  <Route path="/rtmp" element={<RTMPMultistream />} />
                  <Route path="/obs-sync" element={<OBSSync />} />
                  <Route path="/stats" element={<StatsNew />} />
                  <Route path="/donations" element={<Donations />} />
                  <Route path="/goals" element={<Goals />} />
                  <Route path="/console" element={<Console />} />
                  <Route path="/nexus" element={<Nexus />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/permissions" element={<Permissions />} />
                  <Route path="/settings/obs-presets" element={<OBSPresetsSettings />} />
                  <Route path="/settings/:platform" element={<Settings />} />
                </Routes>
              </main>
            </div>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <AlertProvider>
          <Router>
            <AppContent />
          </Router>
        </AlertProvider>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
